import { CharStream, CommonTokenStream, BaseErrorListener } from "antlr4ng";
import { FrendsExpressionLexer } from "./FrendsExpressionLexer";
import { FrendsExpressionParser } from "./FrendsExpressionParser";

export function createParser(text: string, language: string, errorListener?: BaseErrorListener): FrendsExpressionParser {
    const lexer = createLexer(text, language);
    if (errorListener) {
        lexer.addErrorListener(errorListener);
    }
    const parser = new FrendsExpressionParser(new CommonTokenStream(lexer));
    parser.removeErrorListeners();
    if (errorListener) {
        parser.addErrorListener(errorListener);
    }
    return parser;
}

export function createLexer(text: string, language: string): FrendsExpressionLexer {
    const lexer = new FrendsExpressionLexer(CharStream.fromString(text));
    if (language === "csharp") {
        lexer.pushMode(FrendsExpressionLexer.CSHARP_MODE_NO_EXIT);
    }
    lexer.removeErrorListeners();
    return lexer;
}
